export default "__VITE_ASSET__DUM02ssy__"